/**
 * UND WordPress Theme
 * -----------------------------------------------------------------------------
 *
 * Doing the opposite of the SCSS file imports here, only listing the files we
 * are using; UND Framework first, Blog Theme after.
 * 
 * NOTE: You might need to use `require()` instead of `import`.
 */

// Imports



// Polyfills
require( 'ally.js/style/focus-within' )();



// ALL • Run Early
require( './vendor-extensions/und/js/utilities/_fetch-svg' );
require( 'what-input' );
require( '../vendor/und/js/vendor/modernizr/_modernizr' );



// ALL • Vendor



// UND • Vendor Extensions



// UND • Components



// UND • Partials
require( '../vendor/und/js/partials/_menu' );
require( '../vendor/und/js/partials/_header' );
require( '../vendor/und/js/partials/_breadcrumb' );



// UND • Pages



// Blog • Vendor Extensions



// Blog • Components



// Blog • Partials
require( './partials/_featured-posts-slider' );
require( './partials/_forms' );
require( './partials/_site-header-search' );



// Blog • Pages